import { render, staticRenderFns } from "./DingZhiDetail.vue?vue&type=template&id=94a8829c&scoped=true&"
import script from "./DingZhiDetail.vue?vue&type=script&lang=js&"
export * from "./DingZhiDetail.vue?vue&type=script&lang=js&"
import style0 from "./DingZhiDetail.vue?vue&type=style&index=0&id=94a8829c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a8829c",
  null
  
)

export default component.exports